import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { CSSTransition } from "react-transition-group";
import { Box, Typography, IconButton } from "@mui/material";
import SignModal from "./SignModal";
import usericon from "../../assets/images/user-icon.png";
import { useTranslation } from "react-i18next";
import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined';

export default function SignComponent({ classN, drawer = false, stripe = false }) {
  const [showModal, setShowModal] = useState(false);
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <Box display="flex" alignItems="center" justifyContent="center">
      {!drawer &&
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            backgroundColor: stripe ? "#339ace" : "black",
            gap: stripe ? "5px" : "10px",
            borderRadius: stripe ? "15px" : "4em",
            color: "white",
            fontWeight: "bold",
            opacity: stripe ? "1" : "0.5",
            border: "1px solid #339ace",
            padding: stripe ? "5px 10px" : "10px 15px",
            cursor: "pointer",
            "&:hover": { opacity: 1 },
          }}
          onClick={() => navigate("/account")}
        >
          <IconButton sx={{ padding: 0 }}>

            <AccountCircleOutlinedIcon sx={{ color: stripe ? "white" : "gray" }} />
          </IconButton>
          <Typography variant="body1" sx={{ display: { xs: "none", sm: "block" } }}>
            {t("account")}
          </Typography>


        </Box>
      }
      {drawer && <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: '10px',
          color: "white",
          fontWeight: "bold",
          // border: "1px solid #339ace",
          padding: "10px",
        }}
        onClick={() => navigate("/account")}
      >
        <IconButton sx={{ padding: 0 }}>
          <Box
            component="img"
            src={usericon}
            alt="User Icon"
            sx={{ width: "1.2em", height: "1.2em", color: "red" }}
          />
        </IconButton>
        <Typography variant="body1" color="black" >
          {t("account")}
        </Typography>


      </Box>}
      <CSSTransition in={showModal} timeout={200} classNames="sign" unmountOnExit>
        <SignModal classN={classN} setShowModal={setShowModal} />
      </CSSTransition>
    </Box>
  );
}
